import React, { useCallback } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ROUTES from '../../../modules/core/constants/routes';
import classnames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { selectInstitution } from '../../../store/features/system';
import { analyticsUsageViewed, analyticsMeetingHistoryViewed } from '../analytics.utils';
export const AnalyticsTabs = () => {
    const useRoute = useRouteMatch();
    const dispatch = useDispatch();
    const institution = useSelector(selectInstitution);
    const isMeetingHistoryAvailable = institution ? institution.institutionAccess['roomFeatures_viewMeetingHistory'] : true;
    const trackUsage = useCallback(() => dispatch(analyticsUsageViewed({
        button_action: 'open usage',
        context: 'tab'
    })), []);
    const trackMeetingHistory = useCallback(() => dispatch(analyticsMeetingHistoryViewed({
        button_action: 'open meeting history',
        context: 'tab'
    })), []);
    return (<div className="tabs__nav-wrapper">
      <ul className="tabs__nav">
        <li className="tabs__item" onMouseUp={trackUsage}>
          <Link to={ROUTES.analytics()} className={classnames('tabs__link', { 'tabs__link--active': useRoute.url === ROUTES.analytics() })}>
              <FormattedMessage id="account.analytics.usage.usage-title"/>
          </Link>
        </li>
        {isMeetingHistoryAvailable && (<li className="tabs__item" onMouseUp={trackMeetingHistory}>
            <Link to={ROUTES.meetingHistory()} className={classnames('tabs__link', { 'tabs__link--active': useRoute.url === ROUTES.meetingHistory() })}>
              <FormattedMessage id="account.meeting-history.title"/>
            </Link>
          </li>)}
      </ul>
    </div>);
};
